import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from 'antd';

import styles from './styles.css';
import NHFetch from '../../utils/NHFetch.js';

const yxxtBasicUrl = 'api/zhxg-yxxt'; //迎新管理服务后台接口基础路径
const errMaxCount = 3; // 请求异常最大次数
const speed = 15 * 1000; //轮询时间间隔（毫秒）

/**
 * 实时之最展示面板
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-07-04 
 * Version: 1.0
 * Modify log:
 */
class IndexComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            errCount: 0, //连续请求错误次数
            cardData: [], //实时之最统计数据
        }

        this.polling; //轮询定时器
    }

    componentDidMount() {
        this.getData();
    }

    componentWillUnmount() {
        //组件卸载时清除轮询定时器
        clearTimeout(this.polling);
    }

    /**
     * * 获取实时之最统计数据
     *
     * @memberof IndexComponent
     */
    getData = () => {
        NHFetch(yxxtBasicUrl + '/sstj/getStatisticsOfEnrolledDataByLcid', 'GET',{pkid: this.props.pkid})
            .then(res => {
                if (res && res.data) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: 0, cardData: res.data });
                }
            }).catch(err => {
                let errCount = this.state.errCount;
                //如果请求异常次数未超过最大次数限制，则继续尝试
                if (errCount < errMaxCount) {
                    this.polling = setTimeout(() => {
                        this.getData();
                    }, speed);
                    this.setState({ errCount: errCount + 1 });
                } else {
                    //异常超过3次后终止轮询
                    clearTimeout(this.polling);
                }
            });
    }

    /**
     * * 构造实时之最统计数据
     * @memberof Home
     */
    getCardOption = () => {
        const { cardData = [] } = this.state;

        const options = [];
        let listItems = [];

        cardData.map((item, index) => {

            let listItem = (
                <div className={styles.item} key={index}>
                    <span className={styles.name}>
                        {item.title}
                    </span>
                    <span className={styles.zy}>
                        {item.value}
                    </span>
                </div>
            );

            listItems.push(listItem);

            //4个学生为一组滚动显示
            if ((index + 1) % 4 == 0 || index == cardData.length - 1) {
                let v_items = [...listItems];
                let carItem = (
                    <div className={styles.car_item} key={(index + 1) % 4}>
                        <div className={styles.list}>
                            {v_items}
                        </div>
                    </div>
                );
                options.push(carItem);
                listItems = [];
            }

        });

        return options;
    }

    render() {
        return (
            <Carousel
                autoplay
                dots={false}
                style={{ height: '100%' }}
                autoplaySpeed={6000}
                vertical
            >
                {this.getCardOption()}
            </Carousel>
        )
    }

}

IndexComponent.defaultProps = {
}

IndexComponent.propTypes = {
    rem: PropTypes.number,
}

export default IndexComponent;


// WEBPACK FOOTER //
// ./containers/Show/_CardBox2.js